import initMK from './init.js';
import _set from '../set.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import getProp from '../_helpers/getprop.js';
import hasOwn from '../_helpers/hasown.js';
import assign from '../_helpers/assign.js';
function errorAccessor() {
  throw matreshkaError('common:use_magic_props');
}
var libraryMarkers = ['isMatreshka', 'isMatreshkaArray', 'isMatreshkaObject'];
// a setter of the object or of a class it is made by (stops at the library's own prototypes)
function findSetter(object, key) {
  for (var proto = Object.getPrototypeOf(object); proto && proto !== Object.prototype && !libraryMarkers.some(function (marker) {
    return hasOwn(proto, marker);
  }); proto = Object.getPrototypeOf(proto)) {
    var descriptor = Object.getOwnPropertyDescriptor(proto, key);
    if (descriptor) return descriptor.set ? descriptor : undefined;
  }
  return undefined;
}
// the function defines needed descriptor for given property
export default function defineProp(object, key, noAccessor) {
  var def = initMK(object);
  if (!def.props[key]) {
    var descriptor = noAccessor ? undefined : Object.getOwnPropertyDescriptor(object, key);
    if (descriptor && !descriptor.configurable) {
      throw matreshkaError('common:not_configurable', {
        key: key
      });
    }
    var propDef = {
      value: getProp(object, key),
      mediator: null,
      bindings: null
    };
    // a setter (own or a class's) keeps running and gets each new value, and its getter gives the value;
    // a getter alone is replaced
    var accessor = descriptor ? descriptor.set ? descriptor : undefined : noAccessor ? undefined : findSetter(object, key);
    if (accessor) {
      propDef.accessor = {
        get: accessor.get,
        set: accessor.set
      };
    }
    def.props[key] = propDef;
    var getter;
    var setter;
    // sandbox (for all objects) and container (for Matreshka.Array instances) throw on get and on set,
    // so they are hidden from Object.keys and JSON.stringify
    var isReserved = key === 'sandbox' || object.isMatreshkaArray && key === 'container';
    if (isReserved) {
      getter = errorAccessor;
      setter = errorAccessor;
    }
    if (!noAccessor) {
      Object.defineProperty(object, key, {
        configurable: true,
        enumerable: !isReserved,
        get: function get() {
          var _propDef$accessor;
          if (getter) return getter();
          return (_propDef$accessor = propDef.accessor) != null && _propDef$accessor.get ? propDef.accessor.get.call(object) : propDef.value;
        },
        set: function set(v) {
          return setter ? setter() : _set(object, key, v, assign({}, propDef.setterOptions, {
            fromSetter: true
          }));
        }
      });
    }
  }
  return def.props[key];
}